"use client";

import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { setCookie } from "@/services/axiosClient";
import { COOKIES } from "@/app/_libs/constants/cookie";
import { authApi } from "@/services/configuration";

type LoginPayload = { email: string; password: string };
type OtpLoginPayload = { phoneNumber: string; otp: string };

export function useLogin() {
  const router = useRouter();
  return useMutation({
    mutationFn: async (payload: LoginPayload) => {
      const resp = await authApi.authAdminControllerAdminLoginV1(payload as never);
      return resp.data;
    },
    onSuccess: async (data) => {
      try {
        const accessToken = data?.data?.accessToken ?? '';
        const refreshToken = data?.data?.refreshToken ?? '';
        const name = data?.data?.name ?? '';
        const email = data?.data?.email ?? '';

        if (accessToken) {
          await setCookie(COOKIES.ACCESS_TOKEN, accessToken, {
            sameSite: "lax",
            secure: process.env.NODE_ENV === "production",
            maxAge: 60 * 60 * 24 * 7,
          });
        }
        if (refreshToken) {
          await setCookie(COOKIES.REFRESH_TOKEN, refreshToken, {
            sameSite: "lax",
            secure: process.env.NODE_ENV === "production",
            maxAge: 60 * 60 * 24 * 30,
          });
        }
        if (name) await setCookie(COOKIES.USER_NAME, name, { sameSite: "lax" });
        if (email) await setCookie(COOKIES.USER_EMAIL, email, { sameSite: "lax" });
      } catch (e) {
        // ignore cookie failures
      }
      router.replace("/dashboard");
    },
  });
}

export function useOtpLogin(preventRedirect?: boolean, onNext?: () => void) {
  const router = useRouter();
  return useMutation({
    mutationFn: async (payload: OtpLoginPayload) => {
      const resp = await authApi.authAdminControllerAdminLoginV1(payload as never);
      return resp.data;
    },
    onSuccess: async (data) => {
      try {
        const accessToken = data?.data?.accessToken ?? '';
        const refreshToken = data?.data?.refreshToken ?? '';
        const name = data?.data?.name ?? '';
        const email = data?.data?.email ?? '';

        if (accessToken) {
          await setCookie(COOKIES.ACCESS_TOKEN, accessToken, {
            sameSite: "lax",
            secure: process.env.NODE_ENV === "production",
            maxAge: 60 * 60 * 24 * 7,
          });
        }
        if (refreshToken) {
          await setCookie(COOKIES.REFRESH_TOKEN, refreshToken, {
            sameSite: "lax",
            secure: process.env.NODE_ENV === "production",
            maxAge: 60 * 60 * 24 * 30,
          });
        }
        if (name) await setCookie(COOKIES.USER_NAME, name, { sameSite: "lax" });
        if (email) await setCookie(COOKIES.USER_EMAIL, email, { sameSite: "lax" });
      } catch (e) {
        // ignore
      }
      if (preventRedirect) {
        if (onNext) onNext();
      } else {
        router.replace("/dashboard");
      }
    },
  });
}


